import { BehaviorSubject, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { $log } from '@core/utils/logger';
import { WindowRef } from '@vendor/window/window.component';

@Injectable({ providedIn: 'root' })
export class IconService {
    public icons$: BehaviorSubject<any>;

    private iconsPath = 'assets/svg/ihd-icons-def.svg';
    private iconsCollection = {};

    constructor(
        private httpClient: HttpClient,
        private windowRef: WindowRef
    ) {
        this.icons$ = new BehaviorSubject(this.iconsCollection);
    }

    getIcons(): Observable<any> {
        return this.icons$;
    }

    refreshIcons() {
        this.icons$.next(this.iconsCollection);
    }

    getInnerHTML(el) {
        if (el.innerHTML === undefined) {
            let XMLS = new XMLSerializer();
            let nodes = [];
            [].forEach.call(el.childNodes, (childNode) => {
                nodes.push(XMLS.serializeToString(childNode));
            });

            return nodes.join('');
        } else {
            return el.innerHTML;
        }
    }

    fetchIcons() {
        const publicPath = this.windowRef.nativeWindow.PUBLIC_PATH || '/';

        // cache busting the icons
        // const commitHash = compileConfig.commitHash;
        // if (commitHash !== 'in') {
        //     this.iconsPath = this.iconsPath.replace(
        //         'ihd-icons-def.svg',
        //         'ihd-icons-def.' + commitHash + '.svg'
        //     );
        // }

        let iconsURL = this.iconsPath;

        this.httpClient
            .get(iconsURL, {
                responseType: 'text',
            })
            .pipe(
                catchError(
                    (error: any): Observable<any> => {
                        $log.error(error);
                        // return of(this.toastService.showErrorAction(error.error));
                        return of(false);
                    }
                )
            )
            .subscribe((data) => {

                const parsedElement: HTMLElement = document.createElement(
                    'div'
                );
                parsedElement.innerHTML = data;
                const symbols: any = parsedElement.querySelectorAll('symbol');
                for (let i = 0, n = symbols.length; i < n; i++) {
                    let symbol: any = symbols[i];

                    const x = symbol.viewBox?.baseVal?.x || 0;
                    const y = symbol.viewBox?.baseVal?.y || 0;
                    const width = symbol.viewBox?.baseVal?.width || 36;
                    const height = symbol.viewBox?.baseVal?.height || 36;

                    if (symbol.nodeName === 'symbol') {
                        this.iconsCollection[
                            symbol.id
                        ] = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="${width}" height="${height}" viewBox="${x} ${y} ${width} ${height}">${this.getInnerHTML(
                            symbol
                        )}</svg>`;
                    }
                }

                this.icons$.next(this.iconsCollection);
            });
    }
}
